<template>
	<div class="redirect-container">
		<div v-if="loading" class="loader d-flex flex-column align-items-center justify-content-center">
			<!-- <div class="spinner"></div> -->
			<!-- <p>Loading Assessment...</p> -->
		</div>
		<div v-else-if="error" class="error">
			<p>{{ error }}</p>
			<button @click="closeWindow">Close</button>
		</div>
	</div>
</template>

<script>
import { getShareLink } from "../../utils/apiFunctions";
import { mapGetters } from "vuex";

export default {
	name: "AssessmentRedirect",
	data() {
		return {
			loading: true,
			error: null,
		};
	},
	computed: {
		...mapGetters("userVUEX", {
			userInfo: "getUserInfo",
		}),
	},
	async created() {
		const { testID, publicConfigType, isPublic, shareLink, groupID } =
			this.$route.query;

		if (!testID) {
			this.error = "Invalid assessment details.";
			this.loading = false;
			return;
		}

		try {
			// Case 1: Private test or already has link -> direct redirect
			if (isPublic === "false" && shareLink) {
				this.redirectTo(shareLink);
				return;
			}

			// Case 2: Public test -> fetch link
			const res = await getShareLink({
				email: this.userInfo?.email || "", // Handle case where vuex might not be ready, though unlikely if logged in
				testID: testID,
				publicConfigType: publicConfigType || 0,
			});

			if (res.status === 200 && res.data.data.shareLink) {
				this.redirectTo(res.data.data.shareLink);
			} else {
				throw new Error("Failed to generate assessment link.");
			}
		} catch (err) {
			console.error(err);
			this.error = "Unable to load the assessment. Please try again.";
			this.loading = false;
		}
	},
	methods: {
		redirectTo(link) {
			// Append 'from=candidate' query param
			const [baseUrl, fragment] = link.split("#");
			//checking for fragmentation in hire3x url

			if (fragment) {
				const [path, queryString] = fragment.split("?");
				const params = new URLSearchParams(queryString || "");
				params.append("from", "candidate");

				window.location.replace(`${baseUrl}#${path}?${params.toString()}`);
			} else {
				const url = new URL(link);
				url.searchParams.append("from", "candidate");

				window.location.replace(url.href);
			}
		},
		closeWindow() {
			window.close();
		},
	},
};
</script>

<style scoped>
.redirect-container {
	display: flex;
	justify-content: center;
	align-items: center;
	height: 100vh;
	flex-direction: column;
	font-family: sans-serif;
}
.spinner {
	border: 4px solid #f3f3f3;
	border-top: 4px solid #3498db;
	border-radius: 50%;
	width: 40px;
	height: 40px;
	animation: spin 1s linear infinite;
	margin-bottom: 20px;
}
@keyframes spin {
	0% {
		transform: rotate(0deg);
	}
	100% {
		transform: rotate(360deg);
	}
}
.error {
	text-align: center;
	color: #e74c3c;
}
button {
	margin-top: 10px;
	padding: 8px 16px;
	cursor: pointer;
}
</style>
